<ng-container *ngIf="parentFormGroup">
	<div class="flex-auto d-flex w-100 input-field-container">
		<label [for]="inputId" class="flex-grow-1 m-0 text-break">{{ label }}</label>

		<p-inputSwitch
			class="d-flex align-items-center"
			[inputId]="inputId"
			[ngModel]="checked()"
			[ngModelOptions]="{ standalone: true }"
			[disabled]="parentFormGroup.disabled"
			(onChange)="onToggle($event.checked)">
		</p-inputSwitch>
	</div>
</ng-container>
